import { CustomerPremierPartnerServiceConfigurationDTO } from "../DTO/customerPremierPartnerServiceConfigurationDTO";
import { BasicRequest } from "./basicRequest";

export class CreateCustomerPremierPartnerServiceConfigurationRequest extends BasicRequest{

    public premierServiceConfiguration!: CustomerPremierPartnerServiceConfigurationDTO;

    constructor(){
        super();
    }
}